import { clearLongTermTokenFromSessionStorage } from './long-term-token-session-storage';

export const clearSession = () => {
  clearLongTermTokenFromSessionStorage();
};
